import { v4 as UUID } from "uuid";
export enum actionTypes {
  //FetchQuestions
  FETCH_QUESTIONS_REQUEST = "FETCH_QUESTIONS_REQUEST",
  FETCH_QUESTIONS_SUCCESS = "FETCH_QUESTIONS_SUCCESS",
  FETCH_QUESTIONS_FAIL = "FETCH_QUESTIONS_FAIL",
  //CreateQuestion
  CREATE_QUESTION_REQUEST = "CREATE_QUESTION_REQUEST",
  CREATE_QUESTION_SUCCESS = "CREATE_QUESTION_SUCCESS",
  CREATE_QUESTION_FAIL = "CREATE_QUESTION_FAIL",
  //UpdateQuestion
  UPDATE_QUESTION_REQUEST = "UPDATE_QUESTION_REQUEST",
  UPDATE_QUESTION_SUCCESS = "UPDATE_QUESTION_SUCCESS",
  UPDATE_QUESTION_FAIL = "UPDATE_QUESTION_FAIL",
  //UpdateQuestionPublishedStatus
  UPDATE_QUESTION_PUBLISED_STATUS_REQUEST = "UPDATE_QUESTION_PUBLISED_STATUS_REQUEST",
  UPDATE_QUESTION_PUBLISED_STATUS_SUCCESS = "UPDATE_QUESTION_PUBLISED_STATUS_SUCCESS",
  UPDATE_QUESTION_PUBLISED_STATUS_FAIL = "UPDATE_QUESTION_PUBLISED_STATUS_FAIL",
  //UpdateQuestionPublishedStatus
  UPDATE_ANSWER_CORRECT_REQUEST = "UPDATE_ANSWER_CORRECT_REQUEST",
  UPDATE_ANSWER_CORRECT_SUCCESS = "UPDATE_ANSWER_CORRECT_SUCCESS",
  UPDATE_ANSWER_CORRECT_FAIL = "UPDATE_ANSWER_CORRECT_FAIL",
  //DeleteQuestion
  DELETE_QUESTION_REQUEST = "DELETE_QUESTION_REQUEST",
  DELETE_QUESTION_SUCCESS = "DELETE_QUESTION_SUCCESS",
  DELETE_QUESTION_FAIL = "DELETE_QUESTION_FAIL",
}

export interface GenericGroupStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface OptionProps {
  id : string;
  is_correct_answer : boolean;
  option : string;
  updated_at : string;
  video_question_id : string;
}
export interface QuationProps {
  id : string;
  is_published : boolean;
  question : string;
  options : OptionProps[];
  video_id : string;
}

export interface OptionInput {
  option: string;
  is_correct_answer: boolean;
}

export interface QuestionInput {
  question: string;
  is_published: boolean;
  options: OptionInput[];
}

export interface CreateQuestionInput {
  video_id: string;
  questions: QuestionInput[];
}
export interface UpdateQuestionInput {
  video_id: string;
  question: string;
  is_published: boolean;
  options: OptionInput[];
}

export interface UpdateQuestionPublishedStatusInput {
  questionId: string;
  isPublished: boolean;
}

//FetchQuestions
export interface FetchQuestionsRequestAction {
  type: actionTypes.FETCH_QUESTIONS_REQUEST;
}

export interface FetchQuestionsSuccessAction {
  type: actionTypes.FETCH_QUESTIONS_SUCCESS;
  payload: QuationProps[];
}

export interface FetchQuestionsFailureAction {
  type: actionTypes.FETCH_QUESTIONS_FAIL;
  payload: string;
}
//CreateQuestion
export interface CreateQuestionRequestAction {
  type: actionTypes.CREATE_QUESTION_REQUEST;
}
export interface CreateQuestionSuccessAction {
  type: actionTypes.CREATE_QUESTION_SUCCESS;
  payload: QuationProps[];
}
export interface CreateQuestionFailAction {
  type: actionTypes.CREATE_QUESTION_FAIL;
  payload: string;
}
//UpdateQuestion
export interface UpdateQuestionRequestAction {
  type: actionTypes.UPDATE_QUESTION_REQUEST;
}
export interface UpdateQuestionSuccessAction {
  type: actionTypes.UPDATE_QUESTION_SUCCESS;
  payload: QuationProps;
}
export interface UpdateQuestionFailAction {
  type: actionTypes.UPDATE_QUESTION_FAIL;
  payload: string;
}
//UpdateQuestionPublishedStatus
export interface UpdateQuestionPublishedStatusRequestAction {
  type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_REQUEST;
}
export interface UpdateQuestionPublishedStatusSuccessAction {
  type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_SUCCESS;
  payload: QuationProps;
}
export interface UpdateQuestionPublishedStatusFailAction {
  type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_FAIL;
  payload: string;
}
//UpdateAnswerCorrect
export interface UpdateAnswerCorrectRequestAction {
  type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_REQUEST;
}
export interface UpdateAnswerCorrectSuccessAction {
  type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_SUCCESS;
  payload: QuationProps;
}
export interface UpdateAnswerCorrectFailAction {
  type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_FAIL;
  payload: string;
}
//DeleteQuestion
export interface DeleteQuestionRequestAction {
  type: actionTypes.DELETE_QUESTION_REQUEST;
}
export interface DeleteQuestionSuccessAction {
  type: actionTypes.DELETE_QUESTION_SUCCESS;
  payload: typeof UUID;
}
export interface DeleteQuestionFailAction {
  type: actionTypes.DELETE_QUESTION_FAIL;
  payload: string;
}

export type QuestionsActions =
  | FetchQuestionsRequestAction
  | FetchQuestionsSuccessAction
  | FetchQuestionsFailureAction
  | CreateQuestionRequestAction
  | CreateQuestionSuccessAction
  | CreateQuestionFailAction
  | UpdateQuestionRequestAction
  | UpdateQuestionSuccessAction
  | UpdateQuestionFailAction
  | UpdateAnswerCorrectRequestAction
  | UpdateAnswerCorrectSuccessAction
  | UpdateAnswerCorrectFailAction
  | UpdateQuestionPublishedStatusRequestAction
  | UpdateQuestionPublishedStatusSuccessAction
  | UpdateQuestionPublishedStatusFailAction
  | DeleteQuestionRequestAction
  | DeleteQuestionSuccessAction
  | DeleteQuestionFailAction;

